module.exports = __webpack_public_path__ + "img/DownloadEN.6c4878d3.png";